import { AuthProvider, useAuth } from './context/AuthContext';
import { Layout } from './components/Layout';
import { ConsolePage } from './pages/ConsolePage';
import { LoginPage } from './pages/LoginPage';

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <LoginPage />;
  }
  return (
    <Layout>
      <ConsolePage />
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
